
<mat-spinner *ngIf="!isLoaded"></mat-spinner>

<!--<div *ngIf="isLoaded; else spinner">-->
<div>
    <div *ngIf="studyModule; else notfound">
        <!--<h4 class="hide-on-small-only">
            <span *ngIf="this?.studyModuleType?.type !== 'CATEGORY'">{{studyModule?.code}}</span> {{globals.getLocalizedValueIfAny(studyModule?.name)}}<span *ngIf="studyModule?.maxCredits>studyModule?.minCredits">, {{studyModule?.minCredits}}-{{studyModule?.maxCredits}} {{globals.getLocalizedValueIfAny(creditPoints)}}</span><span *ngIf="studyModule?.maxCredits==studyModule?.minCredits && this?.studyModuleType?.type === 'OFFERING'">, {{studyModule?.minCredits}} {{globals.getLocalizedValueIfAny(creditPoints)}}</span>
        </h4>-->

        <!--tämä alempi otsikko näkyy vain mobiilissa
        <h5 class="hide-on-med-and-up">
            <span *ngIf="this?.studyModuleType?.type !== 'CATEGORY'">{{studyModule?.code}}</span> {{globals.getLocalizedValueIfAny(studyModule?.name)}}<span *ngIf="studyModule?.maxCredits>studyModule?.minCredits">, {{studyModule?.minCredits}}-{{studyModule?.maxCredits}} {{globals.getLocalizedValueIfAny(creditPoints)}}</span><span *ngIf="studyModule?.maxCredits==studyModule?.minCredits && this?.studyModuleType?.type === 'OFFERING'">, {{studyModule?.minCredits}} {{globals.getLocalizedValueIfAny(creditPoints)}}</span>
        </h5>-->

        <h1 class="hide-on-med-and-up">
            <span *ngIf="this?.studyModuleType?.type !== 'CATEGORY'">{{studyModule?.code}}</span> {{globals.getLocalizedValueIfAny(studyModule?.name)}}<span *ngIf="studyModule?.maxCredits>studyModule?.minCredits">, {{studyModule?.minCredits}}-{{studyModule?.maxCredits}} {{globals.getLocalizedValueIfAny(creditPoints)}}</span><span *ngIf="studyModule?.maxCredits==studyModule?.minCredits && this?.studyModuleType?.type === 'OFFERING'">, {{studyModule?.minCredits}} {{globals.getLocalizedValueIfAny(creditPoints)}}</span>
        </h1>

        <!-- näytetään laajuus vain, jos se on määritelty kokonaisuudelle-->
        <!--<span *ngIf="studyModule?.maxCredits==studyModule?.minCredits">{{studyModule?.minCredits}}</span> {{globals.getLocalizedValueIfAny(creditPoints)}}</h4>-->

       <!-- <div class="my-container">-->

            <!--Kokonaisuuden tiedot-->
            <div class="flex-content">

                <div *ngFor="let item of studyModule?.contentList" >
                    <div *ngIf="globals.getLocalizedValueIfAny(item?.content)"  class="flex-content-item"> <!--class="col s12 m6"-->
                        <h2>{{globals.getLocalizedValueIfAny(item?.title)}}</h2>
                        <!-- {{globals.getLocalizedValue(item?.content)}}-->
                        <app-markdown [body]="globals.getLocalizedValueIfAny(item?.content)"></app-markdown>
                    </div>
                </div>

            

            <!--RAKENNE-->
            <div  *ngIf="studyModule?.structure">
            
                <h2 *ngIf="structureHeader" class="no-margin-bottom">{{globals.getLocalizedValue(structureHeader)}}</h2>
                <div class="timing-table">
                    <div class="programme-item">
                        <div class="programme-item-elem header"></div>
                        <div *ngIf="creditPoints" class="programme-item-elem centered no-padding-top">{{globals.getLocalizedValue(creditPoints)}}</div>
                    </div>
                </div>
                <!--taulun rivisisältö generoidaan tähän-->
                <div class="timing-table">
                  <structure-unit [unit]="studyModule?.structure" [period]="this.period"></structure-unit>
                </div>
            </div>
        </div>
        <!--</div>-->
    </div>
</div>





<!--<ng-template #spinner>
    <my-spinner></my-spinner>
</ng-template>-->

<ng-template #notfound>
        <!--<h4 class="hide-on-small-only">{{globals.getLocalizedValueIfAny(offeringNotPublished)}}</h4>
        <h5 class="hide-on-med-and-up">{{globals.getLocalizedValueIfAny(offeringNotPublished)}}</h5>-->
        <h5 *ngIf="isLoaded">Not published</h5>
</ng-template>

